export default __webpack_public_path__ + "static/media/Image6.717c515e.png";